var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { t } from 'helpers/i18n';
import { Button } from 'elements';
let UserLogout = class UserLogout extends Component {
    render() {
        return (React.createElement(Button, Object.assign({ onClick: this.props.store.users.logout }, this.props), t('logOut')));
    }
};
UserLogout = __decorate([
    inject('store'),
    observer
], UserLogout);
export default UserLogout;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/containers/UserLogout.tsx
// module id = 546
// module chunks = 0